import { Trans, useTranslation } from 'react-i18next';

import { Text } from '@actual-app/components/text';
import { View } from '@actual-app/components/view';
import type { EnlaceSinUsar } from '@actual-app/core/server/encryption/cofre-app';

import { Icono } from '#components/mobile/ui/Icono';
import { color } from '#components/mobile/ui/tokens';

import { BotonAnularEnlace } from './BotonAnularEnlace';
import { diasHasta } from './tripulacionLogica';

/** Un enlace que nadie ha usado: cuándo caduca, con qué permiso y «Anular». */
export function EnlaceSinUsarFila({
  enlace,
  onAnular,
}: {
  enlace: EnlaceSinUsar;
  onAnular: () => void;
}) {
  const { t } = useTranslation();
  const permiso =
    enlace.permiso === 'ver' ? t('View only') : t('View and edit');
  return (
    <View
      data-testid="enlace-sin-usar"
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        padding: '10px 6px 10px 12px',
        minHeight: 60,
      }}
    >
      <View
        aria-hidden
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          border: `1.5px dashed ${color.line2}`,
          alignItems: 'center',
          justifyContent: 'center',
          color: color.fg2,
          flexShrink: 0,
        }}
      >
        <Icono nombre="clock" size={20} />
      </View>
      <View style={{ flex: 1, minWidth: 0 }}>
        <Text style={{ fontSize: 15, fontWeight: 800 }}>
          <Trans>Unused link</Trans>
        </Text>
        <Text style={{ fontSize: 12.5, fontWeight: 500, color: color.fg2 }}>
          {t('Expires in {{count}} days · {{permission}}', {
            count: diasHasta(enlace.caduca),
            permission: permiso,
          })}
        </Text>
      </View>
      <BotonAnularEnlace data-testid="anular-enlace" onPress={onAnular} />
    </View>
  );
}
